import { Card } from 'react-bootstrap';

function CustomPromptsDescription() {
  return (
    <Card style={{ border: 0 }}>
      <Card.Body>
        <Card.Header>Slide Requirements</Card.Header>
        <ul>
          <li>Dimensions: 1920 x 1080</li>
          <li>Accepted formats: bmp, gif, jpg, png</li>
          <li>No alpha channels</li>
        </ul>
      </Card.Body>
    </Card>
  );
}

export default CustomPromptsDescription;
